import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";

if (Quill && typeof Quill.register === "function") {
  Quill.register("modules/imageResize", ImageResize);
}

const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
  clipboard: { matchVisual: false },
  imageResize: {},
};

const formats = ["header", "bold", "italic", "underline", "list", "bullet", "link", "image"];

export default function CareRichTextEditor({
  value,
  onChange,
  label,
  placeholder = "Add notes...",
  height = 180,
  autoGrow = false,
}) {
  return (
    <div className="care-rich-text-field">
      {label ? <span>{label}</span> : null}
      <ReactQuill
        className={`care-rich-text-editor${autoGrow ? " is-auto-grow" : ""}`}
        formats={formats}
        modules={modules}
        onChange={onChange}
        placeholder={placeholder}
        theme="snow"
        value={value || ""}
      />
      <style>{`
        .care-rich-text-editor .ql-editor {
          min-height: ${height}px;
        }
        .care-rich-text-editor.is-auto-grow .ql-container {
          height: auto;
        }
        .care-rich-text-editor.is-auto-grow .ql-editor {
          height: auto;
          overflow-y: visible;
        }
      `}</style>
    </div>
  );
}
